import { render } from "./DesktopTab.vue?vue&type=template&id=afc7da8e&scoped=true"
import script from "./DesktopTab.vue?vue&type=script&lang=js"
export * from "./DesktopTab.vue?vue&type=script&lang=js"

import "./DesktopTab.vue?vue&type=style&index=0&id=afc7da8e&lang=scss&scoped=true"
import "./DesktopTab.vue?vue&type=style&index=1&id=afc7da8e&scoped=true&lang=css"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afc7da8e"]])

export default __exports__